module.exports = __webpack_public_path__ + "img/flower-top-big.50c2cded.png";